// jivo-smart-loader.js
// Вариант 2: С задержкой по времени + пользовательское взаимодействие
(function() {
    let jivoLoaded = false;

    function loadJivo() {
        if (jivoLoaded || window.jivo) return;

        jivoLoaded = true;
        const script = document.createElement('script');
        script.src = 'https://code.jivo.ru/widget/pKrBkzqIFV';
        script.async = true;
        document.head.appendChild(script);

        // Убираем обработчики после загрузки
        document.removeEventListener('click', loadJivoOnInteraction);
        document.removeEventListener('scroll', loadJivoOnInteraction);
        document.removeEventListener('mousemove', loadJivoOnInteraction);
    }

    // Загрузка по взаимодействию пользователя
    function loadJivoOnInteraction() {
        if (!jivoLoaded) {
            loadJivo();
        }
    }

    // Стратегия загрузки:
    // 1. По таймауту (10 секунд)
    setTimeout(loadJivo, 10_000);

    // 2. По пользовательскому взаимодействию
    document.addEventListener('click', loadJivoOnInteraction, { once: true });
    document.addEventListener('scroll', loadJivoOnInteraction, { once: true, passive: true });
    document.addEventListener('mousemove', loadJivoOnInteraction, { once: true, passive: true });

    // 3. При уходе с страницы (если пользователь собирается уйти)
    document.addEventListener('mouseleave', loadJivo);
})();